import {API_URL, apiPost} from '../api'

export const createTraderMap = async data => {
    return await apiPost(API_URL, 'admin/trader/project', data)
}
